document.addEventListener(
    "click",
    (event) => {
        if (window.innerWidth < 767) {
            if (event.target.matches(".nav-dropdown-title")) {
                document.dispatchEvent(new CustomEvent("nav-dropdown:open"));
            } else if (
                event.target.matches(".content-drawer-close") ||
                event.target.matches(".nav-dropdown-modal-wrapper .overlay")
            ) {
                document.querySelector("details").removeAttribute("open");
            }
        }
    },
    false,
);
